var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpperLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26H23L28 30H46L51 26H64L74 32H0L10 26Z",
    fill: "#7D7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 32H0",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 32H546L573 12M663.5 32H655L628 12",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M537.5 23L567.5 1H632.5L662.5 23",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 536.5,
    y: 22,
    width: 2,
    height: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 661.5,
    y: 22,
    width: 2,
    height: 2,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1136 26H1149L1154 30H1172L1177 26H1190L1200 32H1126L1136 26Z",
    fill: "#7D7C7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 32H663.5",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperLine);
export default __webpack_public_path__ + "static/media/upperLine.0e0d33b2ec82032471ec5184c8edc055.svg";
export { ForwardRef as ReactComponent };